<template>
  <div class="pass-expired-wrapper">
    <div class="w-full px-5">
      <div class="my-4" v-if="!changePasswordSuccess">
        <zt-alert
          :text="alertMessage"
          :color="errorPassword ? 'danger' : 'primary'"
          :closeIcon="false"
        >
          <div slot="icon">
            <div
              class="rounded-full w-24 h-24 flex justify-center items-center border-2 border-zt-primary-200"
              :class="{
                'border-zt-danger': errorPassword,
                'bg-zt-danger': errorPassword
              }"
            >
              <zt-icon
                v-if="errorPassword"
                class="text-5xl ml-px text-zt-white"
                name="shield-asterisk"
              />
              <zt-icon
                v-else
                class="text-5xl mb-1"
                name="exclamation-triangle"
              />
            </div>
          </div>
        </zt-alert>
      </div>
    </div>
    <div class="w-full px-5">
      <div v-if="changePasswordSuccess">
        <ZTModalPasswordExpiredSuccess />
      </div>
      <div v-else class="mx-auto py-3">
        <ZTModalPasswordExpiredFields
          v-model="passExpiredFields"
          :password-policies="passPolicies"
          :passwordIsValid="passwordIsValid"
        />
      </div>
    </div>
    <div class="py-3 px-4 flex justify-end items-center buttons-wrapper">
      <div v-if="!changePasswordSuccess">
        <span
          @click="$emit('goto-switch-company')"
          class="mr-5 cursor-pointer"
          >{{ $t('message.passwordExpired.go_back_btn') }}</span
        >
        <zt-button
          data-vs-button="send-update-password"
          :disabled="
            !isEqualsPassword ||
            passExpiredFields.password === '' ||
            !passwordIsValid
          "
          class="py-3 px-4"
          @click="changePasswordExpired"
          >{{ $t('message.passwordExpired.update_pass_btn') }}</zt-button
        >
      </div>
      <div v-else>
        <zt-button
          data-vs-button="goto-dashboard"
          @click="$emit('goto-dashboard')"
          class="py-3 px-4"
          >{{ $t('message.passwordExpired.go_to_dashboard') }}</zt-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import ZTModalPasswordExpiredFields from '@/components/menu/header-top/pass-expired/modalPasswordExpiredFields.vue'
import ZTModalPasswordExpiredSuccess from '@/components/menu/header-top/pass-expired/modalPasswordExpiredSuccess.vue'
import User from '@/apiClient/User.ts'

export default {
  name: 'PasswordExpiredModal',
  components: {
    ZTModalPasswordExpiredFields,
    ZTModalPasswordExpiredSuccess
  },
  data() {
    return {
      company: '',
      user: '',
      passPolicies: {},
      passExpiredFields: {
        oldPassword: '',
        password: '',
        rePassword: ''
      },
      errorPassword: false,
      errorCode: '',
      changePasswordSuccess: false
    }
  },
  methods: {
    async changePasswordExpired() {
      this.errorPassword = false
      this.errorCode = ''
      await this.user
        .changePassV2(
          this.passExpiredFields.oldPassword,
          this.passExpiredFields.password,
          this.passExpiredFields.rePassword
        )
        .then((response) => {
          if (response.status === 200) {
            this.changePasswordSuccess = true
          }
        })
        .catch((error) => {
          this.errorPassword = true
          this.errorCode = error.response.data.codes[0].code
        })
    },
    async getPasswordPolicies() {
      try {
        const { data } = await this.user.passwordPoliciesV2()
        this.passPolicies = data
      } catch (error) {
        console.error(error)
      }
    }
  },
  computed: {
    alertMessage() {
      let msg = this.$t('message.passwordExpired.pass_expired_message')
      if (this.errorCode !== '') {
        msg = this.$t(
          `message.passwordExpired.message_error.error_${this.errorCode}`
        )
        if (!msg) {
          msg = `message.passwordExpired.message_error.no_handled_error`
        }
      }
      return msg
    },
    passwordIsValid() {
      if (
        (this.errors.items[0] && this.errors.items[0].rule === 'required') ||
        (this.errors.items[0] && this.errors.items[0].rule === 'min') ||
        (this.errors.items[0] && this.errors.items[0].rule === 'regex')
      ) {
        return false
      }
      return true
    },
    isEqualsPassword() {
      return (
        this.passExpiredFields.password === this.passExpiredFields.rePassword
      )
    }
  },
  created() {
    this.user = new User()
    this.getPasswordPolicies()
  }
}
</script>

<style lang="scss" scoped>
.pass-expired-wrapper {
  // width: 430px;
  .buttons-wrapper {
    background-color: #eeeeee;
  }
}
</style>
